import { useEffect, useRef } from 'react';

import { SubmitButton } from '@capsule/consumer-design-system';

import { Form } from 'formik';
import styled from 'styled-components';

import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import { Card, CardItem } from 'src/app/components/Elements/Card';
import { SegmentFormIncomplete } from 'src/app/components/Error/SegmentFormIncomplete';
import { useFocusOnFirstFormError } from 'src/app/components/Form/Hooks/useFocusOnFirstFormError';
import TextInput from 'src/app/components/Form/TextInput';
import DateTextInput from 'src/app/components/Form/TextInput/Date';
import ToggleInput from 'src/app/components/Form/ToggleInput';
import { accountPage, loggedInTransferRx } from 'src/app/router/paths';
import { SAVE_FAMILY_MEMBER_BUTTON } from 'src/consts/testIDs';

import styles from './styles.module.scss';

const toggleValues = [
  { value: 'male', label: 'male' },
  { value: 'female', label: 'female' },
];

const StyledCard = styled(Card)`
  margin-bottom: ${({ theme }) => theme.space.s4};
`;

const AddFamilyMember = ({ previousPath, dispatchSegmentTrack, errors, isSubmitting, isValidating }) => {
  useEffect(() => {
    if (previousPath === accountPage.route) {
      dispatchSegmentTrack(UNIFIED.viewAddFamilyMember, { source: 'Account' });
    } else if (previousPath === loggedInTransferRx.route) {
      dispatchSegmentTrack(UNIFIED.viewAddFamilyMember, { source: 'Transfer Form' });
    }
  }, [previousPath, dispatchSegmentTrack]);
  const formRef = useRef(null);
  useFocusOnFirstFormError(formRef, errors, isSubmitting, isValidating, false);

  return (
    <div className={styles.component}>
      <Form ref={formRef}>
        <SegmentFormIncomplete />
        <StyledCard>
          <CardItem>
            <TextInput name="firstName" label="Legal First Name" />
            <TextInput name="lastName" label="Last Name" />
            <DateTextInput name="birthdate" label="Birthdate" compactStyle />
            <br />
            <ToggleInput name="sex" label="Sex" options={toggleValues} />
          </CardItem>
        </StyledCard>

        <SubmitButton
          variant="outline-lg"
          data-testid={SAVE_FAMILY_MEMBER_BUTTON}
          isSubmitting={isSubmitting}
          isFullWidth
        >
          Save
        </SubmitButton>
      </Form>
    </div>
  );
};

export default AddFamilyMember;
